<template>
  <section class="error-info">
    <h5>---人工故障上报信息---</h5>
    <el-table class="error-table" :data="feedback" border >
      <el-table-column prop="crtName" label="反馈人"></el-table-column>
      <el-table-column prop="fbDate" label="反馈时间" width="160px"></el-table-column>
      <el-table-column prop="fbType" label="反馈类型"></el-table-column>
      <el-table-column prop="spaceNum" label="反馈泊位">
        <template slot-scope="props">
          <span>{{ JSON.parse(props.row.spaceId).spaceNum }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="fbMsg"
        label="反馈内容"
        width="180"
      ></el-table-column>
      <el-table-column label="现场图片" width="200">
        <template slot-scope="props">
          <div style="height:40px;margin:5px 0;">
            <el-image
              v-for="url in props.row.fbImg"
              v-bind:key="url"
              style="width: 40px; height: 40px;border-radius: 5px;margin-right:10px"
              :src="url"
              :preview-src-list="props.row.fbImg"
            >
            </el-image>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </section>
</template>
<script>
export default {
  name: "error-info",
  props: {
    feedback: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  mounted() {
    
  },
};
</script>
<style scoped>
.error-info {
  padding-bottom: 20px;
  box-sizing: border-box;
  /* padding-right: 5%; */
}
h5 {
  padding: 10px 0;
  box-sizing: border-box;
  font-weight: bold;
}
</style>
